module.exports = [{"oid":"","name":""},{"oid":"D","name":"D"},{"oid":"D-E","name":"D-E"},{"oid":"E","name":"E"},{"oid":"F","name":"F"},{"oid":"F-G","name":"F-G"},{"oid":"G","name":"G"},{"oid":"H","name":"H"},{"oid":"I","name":"I"},{"oid":"I-J","name":"I-J"},{"oid":"J","name":"J"},{"oid":"K","name":"K"},{"oid":"K-L","name":"K-L"},{"oid":"L","name":"L"},{"oid":"M","name":"M"},{"oid":"M-N","name":"M-N"},{"oid":"<N","name":"<N"},{"oid":"N","name":"N"}]


//////////////////
// WEBPACK FOOTER
// ./src/config/ZColor.json
// module id = kd/F
// module chunks = 1